import { useAuth0 } from '@auth0/auth0-react';
import { Theme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { createStyles, makeStyles, ThemeProvider } from '@mui/styles';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TokenStoreKey } from '../AppConstants';
import AppContext from '../AppContext';
import SignIn from '../components/Auth/SignIn';
import SpinnerDialog from '../components/Loader/Spinner';
import them from '../themes';
import NavigationScroll from './NavigationScroll';
import Header from './SideMiniDrawer';
import { getLoginUserDetailsByToken } from '../store/actions/App.Actions';
import { toast } from 'react-toastify';

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        '&.boxed': {
            maxWidth: 1280,
            margin: '0 auto',
        },
        '&.container': {
            '&.container': {
                maxWidth: 1120,
                width: '100%',
                margin: '0 auto',
            },
        },
    },
    content: {
        overflow: 'auto',
        flexDirection: 'column',
        '-webkit-overflow-scrolling': 'touch',
        backgroundColor: '#f9f9f9',
    },
}));

const Layout = (props: any) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { isLoading, isAuthenticated, logout, getAccessTokenSilently } = useAuth0();
    const { isAppLoader } = useSelector((state: any) => state.common);
    const { user, authLoader } = useSelector((state: any) => state.auth);
    const [countMakeCall, setCountMakeCall] = useState(0);
    const setToken = async () => {
        const token = await getAccessTokenSilently();
        if (token) {
            localStorage.setItem(TokenStoreKey, token);
            if (!user && !isAppLoader && !isLoading && !authLoader && localStorage.getItem(TokenStoreKey)) {
                if (!sessionStorage.getItem("session")) {
                    sessionStorage.setItem("session", '0');
                }
                if (countMakeCall <= 4) {
                    dispatch(getLoginUserDetailsByToken())
                    setCountMakeCall(countMakeCall + 1);
                }
            }
            if (!user) {
                setCountMakeCall(0);
            }
        }
    }

    if (isAuthenticated && !localStorage.getItem(TokenStoreKey)) {
        setToken();
    }
    const tokenCount = sessionStorage.getItem("session");
    if (tokenCount && +tokenCount >= 3) {
        localStorage.clear();
        sessionStorage.clear();
        logout();
        window.location.reload();
        /* tslint:disable */
        toast('Your session has expired, please login', { type: toast.TYPE.ERROR });
    }

    return (
        <ThemeProvider theme={them}>
            <CssBaseline />
            <AppContext.Consumer>
                {(appContext: any) => (
                    <NavigationScroll>
                        <div className={classes.root}>
                            {(isAppLoader || isLoading) && <SpinnerDialog />}
                            {!isLoading && !isAuthenticated && <SignIn />}
                            {(!isLoading && isAuthenticated) &&
                                <Header logout={logout} routes={appContext.routes} history={props.history} />
                            }
                        </div>
                    </NavigationScroll>
                )}
            </AppContext.Consumer>
        </ThemeProvider>
    );
}

export default Layout;